<template>
    <div class="network_issue_modal" :hidden="hasInternetConnection">
        <div class="network_issue_modal_inner">
            <div class="network_issue_modal_body">
                <img src="@/assets/images/no-internet.svg" alt="No Internet Connection" class="no-internet"
                    :hidden="isOnline">
                <img src="@/assets/images/internet.svg" alt="Internet Connection" class="no-internet"
                    :hidden="!isOnline">
                <h3>Network {{ isOnline ? 'Connected' : 'Disconnected' }}</h3>
                <p v-if="!isOnline">Oh no ... we couldn't connect to the internet. Try checking your internet
                    connection.</p>
                <p v-if="isOnline">Your internet connection is restored.</p>
                <div class="network_issue_modal_btn" :hidden="!isOnline">
                    <button type="button" class="btn btn-success mr-3" @click="rejoinRoom">Reload</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NetworkIssuePopup',
    data() {
        return {
            hasInternetConnection: navigator.onLine,
            isOnline: navigator.onLine,
        };
    },
    mounted() {
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);
        this.updateOnlineStatus();
    },
    beforeUnmount() {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
    },
    methods: {
        updateOnlineStatus() {
            this.isOnline = navigator.onLine;
            if (this.isOnline) {
                // setTimeout(() => {
                //     this.hasInternetConnection = true;
                // }, 1500);
            } else {
                this.hasInternetConnection = false;
            }
        },
        rejoinRoom() {
            window.location.reload();
        },
    },
};
</script>

<style lang="scss" scoped>
.network_issue_modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.92);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000000000;
}

.network_issue_modal[hidden] {
    display: none;
}

.network_issue_modal_inner {
    background-color: #000000;
    padding: 30px;
    border-radius: 12px;
    box-shadow:0px 0px 13px rgba(255, 213, 0, 0.6);
    text-align: center;
    max-width: 400px;
    width: 90%;
    animation: fadeIn 0.3s ease-out;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
}

.network_issue_modal_body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.no-internet {
    width: 100px;
    height: 100px;
    margin-bottom: 15px;
    border-radius: 8px;
}

h3 {
    font-size: 1.8em;
    color: #ffffff;
    margin-bottom: 10px;
}

p {
    font-size: 1.1em;
    color: #efefef;
    line-height: 1.5;
    margin-bottom: 20px;
}

.network_issue_modal_btn {
    margin-top: 10px;
}

.btn {
    font-size: 16px;
    color: #fff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    padding: 10px 5px;
    min-width: 100px;
    line-height: 1;
    border-radius: 3px !important;
    outline: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: none;
}

.btn-success {
    background: rgba(33, 228, 0, 0.5);
}

.btn-success:hover {
    background: #ffe738 !important;
    color: #22292f !important;
}

@media (max-width: 600px) {
    .network_issue_modal_inner {
        padding: 20px;
    }

    h3 {
        font-size: 1.5em;
    }

    p {
        font-size: 1em;
    }

    .btn {
        padding: 10px 20px;
        font-size: 1em;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
